module.exports = __webpack_public_path__ + "img/back-02.9d7b99b8.png";